import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function OtherMallDetails({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    floor_no: false,
  });

  // Slot/Floor options
  const SLOT_FLOOR_OPTIONS = [
    "GF",
    "1F", 
    "2F",
    "3F",
    "4F",
    "5F",
    "6F",
    "7F",
    "Basement 1",
    "Basement 2",
    "Lower Ground",
    "Upper Ground"
  ];



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!primaryDetails.floor_no) {
      errors.floor_no = true;
      toast.error("Please select a slot/floor", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    return !!primaryDetails.floor_no;
  };
  const handleNext = () => {
    if (validateForm()) {
      navigation.go("merchant-location");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">OTHER MALL DETAILS</h4>
                <p className="form-desc">Please provide the mall name and floor details</p>
              </div>
               <div className="form-main">
              <div className="form-main-content">
                <Form>

                  {/* Slot/Floor Selection */}
                  <Form.Group className="mb-5" controlId="floor_no">
                    <Form.Label className="form-label">
                      Slot/Floor <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="floor_no"
                      value={primaryDetails.floor_no || ""}
                      onChange={handleInputChange}
                      className={`form-input${
                        isError.floor_no ? " form-input-error" : ""
                      }`}
                    >
                      <option value="">Select Slot/Floor</option>
                      {SLOT_FLOOR_OPTIONS.map((option, index) => (
                        <option key={`slot-floor-${index}`} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.floor_no && (
                      <div className="form-error">
                        Please select a slot/floor
                      </div>
                    )}
                  </Form.Group>

                  {/* Note */}
                  <div>
                    <p className="form-note-text">
                     <em> Note: Choose the appropriate slot/floor for the mall location</em>
                    </p>
                  </div>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default OtherMallDetails;
